module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_8004.2f14e17e.png";